import { render, staticRenderFns } from "./FormRender.vue?vue&type=template&id=1476ef4d&scoped=true"
import script from "./FormRender.vue?vue&type=script&lang=js"
export * from "./FormRender.vue?vue&type=script&lang=js"
import style0 from "./FormRender.vue?vue&type=style&index=0&id=1476ef4d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1476ef4d",
  null
  
)

export default component.exports